'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _LogService = require('./util/LogService.js');

var _LogService2 = _interopRequireDefault(_LogService);

var _TimeService = require('./util/TimeService.js');

var _TimeService2 = _interopRequireDefault(_TimeService);

var _UtilityService = require('./util/UtilityService.js');

var _UtilityService2 = _interopRequireDefault(_UtilityService);

var _DataCollector = require('./DataCollector.js');

var _DataCollector2 = _interopRequireDefault(_DataCollector);

var _videojs = require('./wrapper/videojs.js');

var _videojs2 = _interopRequireDefault(_videojs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ts_instance = _TimeService2.default.ts_instance;
var us_instance = _UtilityService2.default.us_instance;
var ls_instance = _LogService2.default.ls_instance;

var VBIManager = function VBIManager(config, player, type, extendedData) {
	_classCallCheck(this, VBIManager);

	this.config = config;
	this.dc = new _DataCollector2.default(config);
	var plid = this.dc.getPageLoadID();

	//TODO: Enumerate type
	if (player !== null && type === 'videojs') {
		var _vjsWrapper = new _videojs2.default(player, this.dc);
		this.vjsWrapper = _vjsWrapper;
		_vjsWrapper.registerEventListeners();
	}

	var tsReady = function (ip) {
		if (ip === '') {
			ls_instance.submitLogMessage(plid, "VBIManager", "IP address not returned");
		}

		//TODO: this should be encapsulated in the wrapper files
		if (type === 'videojs') {
			var data_ = us_instance.getPageLoadData();
			var d = Object.assign({}, data_, extendedData);
			ls_instance.submitLogMessage(plid, "VBIManager", "IP address of " + ip + " returned successfully");
			d.ip = ip;

			this.dc.sendPageLoadData(d);
		}
	}.bind(this);

	ts_instance.init(config.timeService, tsReady);
	ls_instance.init(config.logService, config.logIndex, config.logLevel, extendedData);
};

exports.default = VBIManager;